export default "__VITE_ASSET__cEdb0F$t__"